'use client'

import { FaFacebookF, FaGlobe, FaInstagram, FaPhone, FaViber, FaWhatsapp, FaXTwitter } from 'react-icons/fa6'
import { FaRegEnvelope } from 'react-icons/fa'
import clsx from 'clsx'
import {
  openViberChat,
  viberChatHref,
  whatsappChatHref,
} from '@/lib/chat-contact-links'

type PhoneEntry = { phoneNumber: string; label?: string | null }

type ContactItemsProps = {
  phoneNumbers?: PhoneEntry[]
  contactEmail?: string | null
  whatsappNumber?: string | null
  viberNumber?: string | null
  websiteUrl?: string | null
  emailText?: string
  className?: string,
  isSidebar?: boolean
}


export function ServiceContactItems({
  phoneNumbers = [],
  contactEmail,
  whatsappNumber,
  viberNumber,
  websiteUrl,
  emailText,
  className,
  isSidebar
}: ContactItemsProps) {
  if (!phoneNumbers.length && !contactEmail && !whatsappNumber && !viberNumber && !websiteUrl) return null
  const waHref = whatsappNumber ? whatsappChatHref(whatsappNumber) : null
  const ROW_CLASS = clsx('flex items-center gap-3 justify-center rounded-md bg-[#F9F9FD] px-4 py-3 text-sm text-black transition-colors hover:bg-[#ECECF7] dark:bg-muted/45 dark:text-white dark:hover:bg-muted/30', isSidebar ? 'justify-start' : 'justify-center')

  return (
    <div className={className ?? 'grid gap-2'}>
      {phoneNumbers.map((p) => (
        <a
          key={p.phoneNumber}
          href={`tel:${p.phoneNumber.replace(/\s/g, '')}`}
          className={ROW_CLASS}
        >
          <FaPhone className="h-4.5 w-4.5 shrink-0 text-[#22C55E]" />
          Telefon
        </a>
      ))}
      {contactEmail && (
        <a
          href={`mailto:${contactEmail}`}
          className={ROW_CLASS}
        >
          <FaRegEnvelope className="h-4.5 w-4.5 shrink-0 text-black dark:text-white" />
          Email
        </a>
      )}
      {waHref && (
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          className={ROW_CLASS}
        >
          <FaWhatsapp className="h-5 w-5 shrink-0 text-[#25D366]" />
          WhatsApp
        </a>
      )}
      {viberNumber && (
        <a
          href={viberChatHref(viberNumber) ?? '#'}
          className={ROW_CLASS}
          onClick={(e) => {
            e.preventDefault()
            void openViberChat(viberNumber)
          }}
        >
          <FaViber className="h-5 w-5 shrink-0 text-[#7360F2]" />
          Viber
        </a>
      )}
      {websiteUrl && (
        <a
          href={websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={ROW_CLASS}
        >
          <FaGlobe className="h-4.5 w-4.5 shrink-0 text-[#4F46E5]" />
          <span className="lg:hidden">Web</span>
          <span className="hidden lg:inline">Web</span>
        </a>
      )}
    </div>
  )
}

type SocialItemsProps = {
  instagramUrl?: string | null
  facebookUrl?: string | null
  className?: string
}

export function ServiceSocialItems({
  instagramUrl,
  facebookUrl,
  className,
}: SocialItemsProps) {
  if (!instagramUrl && !facebookUrl) return null

  return (
    <div className={className ?? 'flex items-center gap-2'}>
      {instagramUrl && (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-[#F9F9FD] transition-colors hover:bg-[#ECECF7] dark:bg-muted/45 dark:hover:bg-muted/30"
          aria-label="Instagram"
        >
          <FaInstagram className="h-[18px] w-[18px] text-[#E1306C]" />
        </a>
      )}
      {facebookUrl && (
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-[#F9F9FD] transition-colors hover:bg-[#ECECF7] dark:bg-muted/45 dark:hover:bg-muted/30"
          aria-label="Facebook"
        >
          <FaFacebookF className="h-4.5 w-4.5 text-[#1877F2]" />
        </a>
      )}
    </div>
  )
}

